import { css } from 'styled-components'
import { media, mediaDown } from 'styles/media'

export default css`
  .u-hide-small-down {
    ${mediaDown.small`
      display: none !important;
    `};
  }

  .u-hide-small-up {
    ${media.small`
      display: none !important;
    `};
  }

  .u-hide-medium-down {
    ${mediaDown.medium`
      display: none !important;
    `};
  }

  .u-hide-medium-up {
    ${media.medium`
      display: none !important;
    `};
  }

  .u-hide-large-down {
    ${mediaDown.large`
      display: none !important;
    `};
  }

  .u-hide-x-large-down {
    ${mediaDown.xLarge`
      display: none !important;
    `};
  }

  .u-hide-large-up {
    ${media.large`
      display: none !important;
    `};
  }

  .u-text-right {
    text-align: right !important;
  }

  .u-text-center {
    text-align: center !important;
  }

  .u-text-right-medium-up {
    ${media.medium`
      text-align: right !important;
    `};
  }

  .u-text-center-medium-up {
    ${media.medium`
      text-align: center !important;
    `};
  }

  .u-flex {
    display: flex;
  }

  .u-block {
    display: block !important;
  }
`
